/**
 * MMEC canonical Arabic options/stocks terminology.
 * Source: data/mmec_options_glossary.json (hawamer.com + translations.ts)
 */
import glossary from '../data/mmec_options_glossary.json';

type Glossary = {
  en_to_ar?: Record<string, string>;
  phrase_fixes?: string[][];
  word_fixes?: Record<string, string>;
};

const G = glossary as unknown as Glossary;

export function enToAr(term: string): string {
  const key = (term || '').trim().toLowerCase();
  return (G.en_to_ar && G.en_to_ar[key]) || '';
}

/** Normalize wrong Arabic options wording to MMEC canonical terms. */
export function applyMmecArabicDictionary(text: string): string {
  if (!text?.trim()) return text || '';

  let out = text;
  const phrases = [...(G.phrase_fixes || [])].sort((a, b) => b[0].length - a[0].length);
  for (const [wrong, right] of phrases) {
    if (wrong && right) out = out.split(wrong).join(right);
  }

  const words = G.word_fixes || {};
  for (const [wrong, right] of Object.entries(words)) {
    if (!wrong || !right) continue;
    const re = new RegExp(`(?<![\\w\\u0600-\\u06FF])${wrong}(?![\\w\\u0600-\\u06FF])`, 'g');
    out = out.replace(re, right);
  }

  const enMap = G.en_to_ar || {};
  for (const [en, ar] of Object.entries(enMap).sort((a, b) => b[0].length - a[0].length)) {
    if (!en || !ar || en.length < 2) continue;
    const re = new RegExp(`\\b${en.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'gi');
    out = out.replace(re, ar);
  }

  return out.replace(/\s{2,}/g, ' ').trim();
}

export function hasForeignLeakInArabic(text: string): boolean {
  if (!text?.trim()) return false;
  return /\b(como|opciones?|optiones?|mercado|top\s+opci|the\s+market)\b/i.test(text);
}

/** Display-safe Arabic: dictionary + reject obvious LLM garbage. */
export function guardArabicCompanionCopy(text: string, fallback: string): string {
  const t = (text || '').trim();
  if (!t || hasForeignLeakInArabic(t)) return fallback;
  return applyMmecArabicDictionary(t);
}
